<template>
    <div class="content">

        <div class='cart_container'>
            <div class="cart">
                <!-- <div id="step">
                    <div class="step active">
                        購物車內容
                    </div>
                    <div class="step_pipe active"></div>
                    <div class="step">
                        付款運送方式
                    </div>
                    <div class="step_pipe"></div>
                    <div class="step">
                        購物車內容
                    </div>
                </div> -->
                <div id="detail">
                    <div class="list">
                        <div class="title" @click="up_down = !up_down">
                            <span>結帳金額</span>
                            <div class="icon">
                                <div :class="up_down ? 'display_none' : ''"><span class="up" data-fa-i2svg=""><svg
                                            class="svg-inline--fa fa-angle-up fa-w-10" aria-hidden="true"
                                            focusable="false" data-prefix="fa" data-icon="angle-up" role="img"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg="">
                                            <path fill="currentColor"
                                                d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z">
                                            </path>
                                        </svg></span></div>
                                <div :class="up_down ? '' : 'display_none'"><span class="down" data-fa-i2svg=""><svg
                                            class="svg-inline--fa fa-angle-down fa-w-10" aria-hidden="true"
                                            focusable="false" data-prefix="fa" data-icon="angle-down" role="img"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg="">
                                            <path fill="currentColor"
                                                d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z">
                                            </path>
                                        </svg></span></div>
                            </div>
                        </div>
                        <hr>
                        <div class="subtotal" :style="!up_down ? 'height: 0px' : ' height: 35px'">
                            <div class="list_row">
                                <span>商品小計</span>
                                <span>${{ totalPriceAfterShipment | formatNumberToqff }}</span>
                            </div>
                            <hr>
                        </div>
                        <div class="freight">
                            <div class="list_row">
                                <span>運費</span>
                                <span>{{ freight.total }}</span>
                            </div>
                            <hr>
                        </div>
                        <div class="total">
                            <div class="list_row">
                                <span class="total_title bottom">應付總額</span>
                                <span class="total_price">
                                    <span style="margin-right: 5px;">$</span>
                                    <span style="font-size: 22px; vertical-align: bottom; font-weight: bold;">{{
                                        cart_list.total }}</span>
                                </span>
                            </div>
                            <div style="line-height:1.5;text-align: right; margin-top: 10px;">
                                (實際結帳金額為 ${{ cart_list.total }})
                            </div>
                        </div>
                    </div>
                    <div class="list" style=" margin-top: 16px; margin-bottom: 16px;">
                        <div class="title" @click="cart_contents = !cart_contents">
                            <span>購物車內容</span>
                            <div class="icon">
                                <div :class="cart_contents ? 'display_none' : ''"><span class="up" data-fa-i2svg=""><svg
                                            class="svg-inline--fa fa-angle-up fa-w-10" aria-hidden="true"
                                            focusable="false" data-prefix="fa" data-icon="angle-up" role="img"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg="">
                                            <path fill="currentColor"
                                                d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z">
                                            </path>
                                        </svg></span></div>
                                <div :class="cart_contents ? '' : 'display_none'"><span class="down"
                                        data-fa-i2svg=""><svg class="svg-inline--fa fa-angle-down fa-w-10"
                                            aria-hidden="true" focusable="false" data-prefix="fa" data-icon="angle-down"
                                            role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"
                                            data-fa-i2svg="">
                                            <path fill="currentColor"
                                                d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z">
                                            </path>
                                        </svg></span></div>
                            </div>
                        </div>
                        <hr>
                        <div id="subtotal" class="subtotal" :style="subtotalStyle">
                            <div class="line_row" v-for="item in cart_list_item">
                                <p>{{ item.form_name }}</p>
                                <div class="list_row">
                                    <span></span>
                                    <span>數量：{{ item.num }}</span>
                                </div>
                            </div>
                            <hr>
                        </div>
                    </div>
                </div>
                <div id="main">
                    <div class="cart_content">
                        <div class="cart_content_header">購物車內容</div>
                        <table class="cart_content_table cl-hidden--mobile">
                            <colgroup>
                                <col style="width: 0px;">
                            </colgroup>
                            <thead class="table_head">
                                <tr>
                                    <th style="text-align: left;" colspan="2">
                                        <div data-translate-keys="product-details" data-translate-html="true">商品明細</div>
                                    </th>
                                    <th style="min-width: 88px;">
                                        <div data-translate-keys="unit-price" data-translate-html="true">單價</div>
                                    </th>
                                    <th style="min-width: 170px;">
                                        <div data-translate-keys="quantity" data-translate-html="true">數量</div>
                                    </th>
                                    <th style="min-width: 88px;">
                                        <div data-translate-keys="sub-total" data-translate-html="true">小計</div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody class="table_tbody">
                                <tr class="list_item" v-for="item, index in cart_list_item">
                                    <td class="td_img" rowspan="1" valign="top">
                                        <a href="javascript:;">
                                            <div class="item_img default_scale"><img class="img-responsive"
                                                    :alt="item.form_name" :src="item.display_img_small">
                                            </div>
                                        </a>
                                    </td>
                                    <td class="td_name" valign="top"><a class="cl-a" href="javascript:;">{{
                                        item.form_name
                                            }}</a>
                                        <div class="line-item-note" v-for="sub in item.sub">
                                            <span v-if="sub.num !== 0">
                                                <span v-if="sub.sub_type == 'SFREE'" style="color: #dc3545;">- 贈品-{{
                                                    sub.form_name }}*{{ sub.num }}</span>
                                                <span v-else>- {{ sub.form_name }}*{{ sub.num }}</span></span>
                                        </div>
                                    </td>
                                    <td class="td_price"><span data-money-format="true">${{ item.price }}</span></td>
                                    <td class="td_group">
                                        <div class="quantity_button">
                                            <!-- <input type="text" class="scarecrow-input"> -->
                                            <div type="button" class="reduce_button " @click="reduce(item, index)">-
                                            </div>
                                            <div class="quantity ">
                                                <input class="form-control" @change="changebalue(item, index)"
                                                    v-model="item.num">
                                            </div>
                                            <div type="button" class="add_button " @click="add(item, index)">+</div>
                                        </div>
                                    </td>
                                    <td class="sub-total"><span data-money-format="true">${{ item.total }}</span></td>
                                    <td class="td_del">
                                        <button type="button" class="delete-button" @click="del(item, index)">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M15.7071 1.70711C16.0976 1.31658 16.0976 0.683418 15.7071 0.292893C15.3166 -0.0976309 14.6834 -0.0976309 14.2929 0.292893L8 6.58579L1.70711 0.292893C1.31658 -0.0976309 0.683418 -0.0976309 0.292893 0.292893C-0.0976309 0.683418 -0.0976309 1.31658 0.292893 1.70711L6.58579 8L0.292893 14.2929C-0.0976309 14.6834 -0.0976309 15.3166 0.292893 15.7071C0.683418 16.0976 1.31658 16.0976 1.70711 15.7071L8 9.41421L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L9.41421 8L15.7071 1.70711Z"
                                                    fill="#565656"></path>
                                            </svg></button>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot class="table_footer">
                                <tr>
                                    <td colspan="6">
                                        <div><span data-translate-keys="order-cart-includes"
                                                data-translate-html="true">購物車內合計有</span><span> {{
                                                cart_list_item?.length }}
                                            </span><span data-translate-keys="products-unit"
                                                data-translate-html="true">項</span><span data-translate-keys="products"
                                                data-translate-html="true">商品</span></div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                        <div class="cl-hidden--pc line-items">
                            <div class="product-details">商品明細</div>
                            <div class="items" v-for="item, index in cart_list_item">
                                <button class="delete-button" @click="del(item)">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M15.7071 1.70711C16.0976 1.31658 16.0976 0.683418 15.7071 0.292893C15.3166 -0.0976309 14.6834 -0.0976309 14.2929 0.292893L8 6.58579L1.70711 0.292893C1.31658 -0.0976309 0.683418 -0.0976309 0.292893 0.292893C-0.0976309 0.683418 -0.0976309 1.31658 0.292893 1.70711L6.58579 8L0.292893 14.2929C-0.0976309 14.6834 -0.0976309 15.3166 0.292893 15.7071C0.683418 16.0976 1.31658 16.0976 1.70711 15.7071L8 9.41421L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L9.41421 8L15.7071 1.70711Z"
                                            fill="#565656"></path>
                                    </svg>
                                </button>
                                <div class="items_content">
                                    <div class="img_content">
                                        <a href="javascipt:;">
                                            <div class="img">
                                                <img class="img-responsive" :alt="item.form_name"
                                                    :src="item.display_img_small">
                                            </div>
                                        </a>
                                        <div class="content">
                                            <div class="title"><a class="cl-a" href="javascript:;">{{ item.form_name
                                                    }}</a>
                                                <div class="line-item-note" v-for="sub in item.sub">
                                                    <span v-if="sub.num !== 0">
                                                        <span v-if="sub.sub_type == 'SFREE'" style="color: #dc3545;">-
                                                            贈品-{{
                                                            sub.form_name }}*{{ sub.num }}</span>
                                                        <span v-else>- {{ sub.form_name }}*{{ sub.num }}</span></span>
                                                </div>
                                            </div>
                                            <span data-money-format="true">${{ item.price }}</span>
                                        </div>
                                    </div>
                                    <div class="num_price">
                                        <div class="number">
                                            <div class="quantity_button">
                                                <!-- <input type="text" class="scarecrow-input"> -->
                                                <div type="button" style="line-height: 2.2em;" class="reduce_button "
                                                    @click="reduce(item, index)">-</div>
                                                <div class="quantity ">
                                                    <input class="form-control" v-model="item.num"
                                                        @change="changebalue(item, index)">
                                                </div>
                                                <div type="button" style="line-height: 2.2em;" class="add_button "
                                                    @click="add(item, index)">+</div>
                                            </div>
                                        </div>
                                        <div class="price">
                                            <span>${{ item.total }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer">
                                購物車內合計有 1 項商品
                                <hr>
                            </div>
                        </div>
                    </div>
                    <div class="addcart_list">
                        <h3>訂單加價購商品區</h3>
                        <div class="list">
                            <div class="list_item" v-for="item in addpurchase_list">
                                <div class="img">
                                    <img :src="item.display_img_small" alt="">
                                </div>
                                <div class="contents">
                                    <div class="title">{{ item.form_name }}</div>
                                    <div class="price">${{ item.price }}</div>
                                    <div class="addcart">
                                        <button type="button" class="addcart_button"
                                            @click="addcart(item)">加入購物車</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ValidationObserver v-slot="{ handleSubmit }">
                        <form @submit.prevent="handleSubmit(goorder)">
                            <div class="cart_user">
                                <div class="cart_user_header">
                                    付款運送方式
                                </div>
                                <div class="cart_user_content">
                                    <div class="shopping_detail">
                                        <div class="logistics">
                                            <p>*請選擇物流</p>
                                            <ValidationProvider rules="address" v-slot="{ errors, classes }">
                                                <input type="radio" v-model="selectedButton" style="display: none;">
                                                <div class="logistics_group">
                                                    <button type="button" class="form-control"
                                                        :class="{ active: selectedButton === 'default' }"
                                                        @click="selectButton('default')">
                                                        <div class="shipping-label grid-label">
                                                            <div class="title"><span>宅配</span></div>
                                                            <div class="sub-label"><span class="color oran"></span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                    <button v-for="item in logistics.cvs" type="button"
                                                        class="form-control"
                                                        :class="{ active: selectedButton === item.lkey }"
                                                        @click="selectButton(item.lkey)">
                                                        <div class="shipping-label grid-label">
                                                            <div class="title"><span>{{ item.name }}</span></div>
                                                            <div class="sub-label"><span class="color oran"></span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                    <span v-if="errors[0]" class="payerrors"><svg
                                                            xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                            viewBox="0 0 20 20"
                                                            style="margin-top: -2px; margin-right: 6px;">
                                                            <g fill="none" fill-rule="evenodd">
                                                                <g fill="#DC3545">
                                                                    <path
                                                                        d="M10.001 0C4.477 0 0 4.477 0 10s4.477 10 10.001 10C15.523 20 20 15.523 20 10S15.523 0 10.001 0m0 2c4.412 0 8 3.59 8 8 0 4.411-3.588 8-8 8C5.59 18 2 14.411 2 10c0-4.41 3.591-8 8.002-8"
                                                                        transform="translate(-432 -1263) translate(416 1253) translate(16 10)">
                                                                    </path>
                                                                    <path
                                                                        d="M10 13.34c-.553 0-1-.448-1-1V4.391c0-.551.447-1 1-1 .553 0 1 .449 1 1v7.947c0 .553-.447 1-1 1M11.06 15.642c0 .586-.474 1.06-1.06 1.06-.585 0-1.06-.474-1.06-1.06 0-.586.475-1.06 1.06-1.06.586 0 1.06.474 1.06 1.06"
                                                                        transform="translate(-432 -1263) translate(416 1253) translate(16 10)">
                                                                    </path>
                                                                </g>
                                                            </g>
                                                        </svg>{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <hr style="margin: 16px -16px;">
                                        <div class="payment">
                                            <p>*付款方式</p>
                                            <ValidationProvider rules="pay" v-slot="{ errors, classes }">
                                                <input type="text" v-model="payButton" style="display: none;">
                                                <div class="payment_group">
                                                    <button type="button" v-for="item in payment_method"
                                                        :class="['form-control', { active: payButton === item.pay_mode }]"
                                                        @click="select_payButton(item.pay_mode)">
                                                        <div class="shipping-label grid-label">
                                                            <div class="title"><span>{{ item.alias }}</span></div>
                                                            <div class="sub-label">
                                                                <!-- <span class="color oran">
                                                                <span data-translate-keys="reach-free-shipping"
                                                                    data-translate-html="true">達免運門檻</span>
                                                            </span> -->
                                                            </div>
                                                        </div>
                                                    </button>
                                                    <span v-if="errors[0]" class="payerrors"><svg
                                                            xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                            viewBox="0 0 20 20"
                                                            style="margin-top: -2px; margin-right: 6px;">
                                                            <g fill="none" fill-rule="evenodd">
                                                                <g fill="#DC3545">
                                                                    <path
                                                                        d="M10.001 0C4.477 0 0 4.477 0 10s4.477 10 10.001 10C15.523 20 20 15.523 20 10S15.523 0 10.001 0m0 2c4.412 0 8 3.59 8 8 0 4.411-3.588 8-8 8C5.59 18 2 14.411 2 10c0-4.41 3.591-8 8.002-8"
                                                                        transform="translate(-432 -1263) translate(416 1253) translate(16 10)">
                                                                    </path>
                                                                    <path
                                                                        d="M10 13.34c-.553 0-1-.448-1-1V4.391c0-.551.447-1 1-1 .553 0 1 .449 1 1v7.947c0 .553-.447 1-1 1M11.06 15.642c0 .586-.474 1.06-1.06 1.06-.585 0-1.06-.474-1.06-1.06 0-.586.475-1.06 1.06-1.06.586 0 1.06.474 1.06 1.06"
                                                                        transform="translate(-432 -1263) translate(416 1253) translate(16 10)">
                                                                    </path>
                                                                </g>
                                                            </g>
                                                        </svg>{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="remark">
                                            <p>備註</p>
                                            <div> <textarea rows="1" placeholder="備註" v-model="remark"
                                                    style="min-width: 100%; max-width: 100%; width: 100%;"></textarea>
                                            </div>
                                        </div>
                                        <hr style="margin: 16px -16px;">
                                        <div class="buy">
                                            <p>購買人資訊</p>
                                            <p>*姓名</p>
                                            <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                                <input :class="classes" @blur="insert($event)" type="text"
                                                    v-model="name" placeholder="購買人姓名">
                                                <span class="error">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                            <p>*聯絡電話</p>
                                            <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                                <input :class="classes" type="tel" @blur="insert($event)"
                                                    v-model="phone" placeholder="購買人聯絡電話，例：0987654321">
                                                <span class="error">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                            <p>*購買人地址</p>
                                            <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                                <div class="address">
                                                    <select :class="classes" v-model="selectedName"
                                                        @change="onNameChange">
                                                        <option disabled value="">請選擇縣/市</option>
                                                        <option v-for="address in address" :key="address.name"
                                                            :value="address.name">
                                                            {{ address.name }}
                                                        </option>
                                                    </select>

                                                    <select :class="classes" v-model="selectedCity">
                                                        <option disabled value="">請選擇鄉鎮市區</option>
                                                        <option v-for="city in selectedCitys" :key="city" :value="city">
                                                            {{ city }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </ValidationProvider>
                                            <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                                <input :class="classes" v-model="enteraddress" type="text"
                                                    @blur="insert($event)" placeholder="請填寫詳細購買人地址：路/巷/弄/號/樓">
                                                <span class="error">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                            <p>電子發票索取方式</p>
                                            <select v-model="bill" style="width: 100%; margin-bottom: 16px;"
                                                @change="changebill($event)">
                                                <option disabled value="0">請選擇</option>
                                                <option value="1">愛心捐贈</option>
                                                <option value="2">寄送至郵箱</option>
                                            </select>
                                            <p><span v-show="bill == 2">*</span>電子信箱</p>
                                            <ValidationProvider :rules="bill == 1 ? 'email' : 'required|email'"
                                                v-slot="{ errors, classes }">
                                                <input :class="classes" v-model="email" @blur="insert($event)"
                                                    type="email" placeholder="請輸入電子信箱">
                                                <span class="error">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                            <div v-show="bill == 2">

                                                <p>*受買人名字</p>
                                                <ValidationProvider :rules="bill == 1 ? '' : 'required|'"
                                                    v-slot="{ errors, classes }">
                                                    <input :class="classes" type="text" v-model="company"
                                                        placeholder="請輸入受買人名字">
                                                    <span class="error">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                                <p>統一編號（選填）</p>
                                                <input type="text" v-model="unite_number" placeholder="請輸入統一編號">
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pay">
                                <button>立即結帳</button>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>


            <el-dialog :visible.sync="ChildDialogVisible" class="child_dialog" :close-on-click-modal="false"
                :close-on-press-escape="false">
                <!-- <Child_list @dialog_close="dialog_close" :list_itemid="this.list_itemid" :child_list="this.child_list"
                :child_num="this.child_num" :list_num="this.list_num"></Child_list> -->
                <h2>請選擇 {{ this.child_num }} 份商品</h2>
                <div v-for="item, index in child_list">
                    <div class="form_name">{{ item.form_name }}</div>
                    <div class="number">
                        <button type="button" class="btn iconfont" @click="decrement(index)">-
                        </button>
                        <input type="number" name="quantity" @input="validateInput(index)" v-model="item.display_num"
                            class="border-0 text-center w-100   p-0" data-max="1" data-min="1">
                        <button type="button" class="btn iconfont" @click="increment(index)">+
                        </button>
                    </div>
                </div>
                <div class="btn">
                    <button @click="checkChild_list(false)">確認</button>
                </div>
            </el-dialog>
        </div>
        <Navbar></Navbar>
    </div>
</template>

<script>
import Navbar from '@/components/navbar/index.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapState } from 'vuex';
import numeral from "numeral";
import FacebookEventApi from '@/js/FacebookEventApi';
import GA4EventApi from '@/js/GA4EventApi';
export default {
    components: {
        Navbar,
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            //子商品
            child_list: [],//子商品内容
            child_num: 0,//子商品默认数量
            child_number: '',//记录商品数量总和
            parm: [],//修改后的子商品各个的数量

            //赠品
            free: [],//赠品
            free_num: '',//赠品数量
            free_number: '',//记录赠品数量总和
            free_parm: [],//修改后的赠品各个的数量

            issub: false,//是否有子商品
            ChildDialogVisible: false,//子商品弹窗
            commodity_num: 0,//商品修改后的数量
            commodity_id: '',//商品id
            up_down: false,
            cart_contents: true,
            contentheight: '0px',
            address: [
                {
                    name: "台北市",
                    citys: [
                        "中正區",
                        "大同區",
                        "中山區",
                        "松山區",
                        "大安區",
                        "萬華區",
                        "信義區",
                        "士林區",
                        "北投區",
                        "內湖區",
                        "南港區",
                        "文山區",
                    ],
                },
                {
                    name: "基隆市",
                    citys: [
                        "仁受區",
                        "信義區",
                        "中正區",
                        "中山區",
                        "安樂區",
                        "暖暖區",
                        "七堵區",
                    ],
                },
                {
                    name: "新北市",
                    citys: [
                        "萬里區",
                        "金山區",
                        "板橋區",
                        "汐止區",
                        "深坑區",
                        "石碇區",
                        "瑞芳區",
                        "平溪區",
                        "雙溪區",
                        "貢寮區",
                        "新店區",
                        "坪林區",
                        "烏來區",
                        "永和區",
                        "中和區",
                        "土城區",
                        "三峽區",
                        "樹林區",
                        "鶯歌區",
                        "三重區",
                        "新莊區",
                        "泰山區",
                        "林口區",
                        "蘆洲區",
                        "五股區",
                        "八里區",
                        "淡水區",
                        "三芝區",
                        "石門區",
                    ],
                },
                {
                    name: "宜蘭縣",
                    citys: [
                        "宜蘭市",
                        "頭城鎮",
                        "礁溪鄉",
                        "壯圍鄉",
                        "員山鄉",
                        "羅東鎮",
                        "三星鄉",
                        "大同鄉",
                        "五結鄉",
                        "冬山鄉",
                        "蘇澳鎮",
                        "南澳鄉",
                    ],
                },
                {
                    name: "新竹市",
                    citys: ["北區", "東區", "香山區"],
                },
                {
                    name: "新竹縣",
                    citys: [
                        "竹北市",
                        "湖口鄉",
                        "新豐鄉",
                        "新埔鎮",
                        "關西鎮",
                        "芎林鄉",
                        "赛山鄉",
                        "竹東鎮",
                        "五峰鄉",
                        "橫山鄉",
                        "尖石鄉",
                        "北埔鄉",
                        "峨眉鄉",
                    ],
                },
                {
                    name: "桃園市",
                    citys: [
                        "中壢區",
                        "平鎮區",
                        "龍潭區",
                        "楊梅區",
                        "新屋區",
                        "觀音區",
                        "桃園區",
                        "龜山區",
                        "八德區",
                        "八溪區",
                        "復興區",
                        "大園區",
                        "蘆竹區",
                    ],
                },
                {
                    name: "苗栗縣",
                    citys: [
                        "竹南鎮",
                        "頭份市",
                        "三灣鄉",
                        "南庄鄉",
                        "獅潭鄉",
                        "後龍鎮",
                        "通霄鎮",
                        "苑裡鎮",
                        "苗栗市",
                        "造橋鄉",
                        "頭屋鄉",
                        "公館鄉",
                        "大湖鄉",
                        "泰安鄉",
                        "銅鑼鄉",
                        "三義鄉",
                        "西湖鄉",
                        "卓蘭鎮",
                    ],
                },
                {
                    name: "台中市",
                    citys: [
                        "中區",
                        "東區",
                        "南區",
                        "西區",
                        "北區",
                        "北屯區",
                        "西屯區",
                        "南屯區",
                        "太平园",
                        "大里區",
                        "霧峰區",
                        "烏日區",
                        "豐原區",
                        "后里區",
                        "石岡區",
                        "東势區",
                        "和平區",
                        "新社區",
                        "潭子區",
                        "大雅區",
                        "神岡區",
                        "大肚區",
                        "沙鹿區",
                        "龍井區",
                        "梧棲區",
                        "清水區",
                        "大甲區",
                        "外埔區",
                        "大安區",
                    ],
                },
                {
                    name: "彰化縣",
                    citys: [
                        "彰化市",
                        "芬園鄉",
                        "花壇鄉",
                        "秀水鄉",
                        "鹿港鎮",
                        "福興鄉",
                        "線西鄉",
                        "和美鎮",
                        "伸港鄉",
                        "員林市",
                        "社頭鄉",
                        "永靖鄉",
                        "埔心鄉",
                        "溪湖鎮",
                        "大村鄉",
                        "埔鹽鄉",
                        "田中鎮",
                        "北斗鎮",
                        "田尾鄉",
                        "埤頭鄉",
                        "溪州鄉",
                        "竹塘鄉",
                        "二林鎮",
                        "大城鄉",
                        "芳苑鄉",
                        "二水鄉",
                    ],
                },
                {
                    name: "南投縣",
                    citys: [
                        "南投市",
                        "中寮鄉",
                        "草屯鎮",
                        "國姓鄉",
                        "埔里鎮",
                        "仁愛鄉",
                        "名間鄉",
                        "集集鎮",
                        "水里鄉",
                        "魚池鄉",
                        "信義鄉",
                        "竹山鎮",
                        "鹿谷鄉",
                    ],
                },
                {
                    name: "嘉義市",
                    citys: ["西區", "東區"],
                },
                {
                    name: "嘉義縣",
                    citys: [
                        "番路鄉",
                        "梅山鄉",
                        "竹崎鄉",
                        "阿里山鄉",
                        "中埔鄉",
                        "大埔鄉",
                        "水上鄉",
                        "鹿草鄉",
                        "太保市",
                        "朴子市",
                        "東石鄉",
                        "六腳鄉",
                        "新港鄉",
                        "民雄鄉",
                        "大林鎮",
                        "溪口鄉",
                        "義竹鄉",
                        "布袋鎮",
                    ],
                },
                {
                    name: "雲林縣",
                    citys: [
                        " 斗南鎮",
                        "大埤鄉",
                        "虎尾鎮",
                        "土庫鎮",
                        "褒忠娜",
                        "東势鄉",
                        "台西鄉",
                        "褒忠娜",
                        "東势鄉",
                        "台西鄉",
                        "斋背鄉",
                        "麥寮鄉",
                        "斗六市",
                        "林内鄉",
                        "古坑鄉",
                        "莉桐娜",
                        "西螺鎮",
                        "二斋鄉",
                        "北港鎮",
                        "水林鄉",
                        "口湖鄉",
                        "四湖鄉",
                        "元長鄉",
                    ],
                },
                {
                    name: "台南市",
                    citys: [
                        "中西區",
                        "東區",
                        "南區",
                        "北區",
                        "安平區",
                        "安南區",
                        "永康區",
                        "歸仁區",
                        "新化區",
                        "左鎮區",
                        "玉井區",
                        "楠西區",
                        "南化區",
                        "仁德區",
                        "關廟區",
                        "龍崎區",
                        "官田區",
                        "麻豆區",
                        "佳里區",
                        "西港區",
                        "七股區",
                        "將軍區",
                        "學甲區",
                        "北門區",
                        "新營區",
                        "後壁區",
                        "白河區",
                        "東山區",
                        "六甲區",
                        "下營區",
                        "柳營區",
                        "鹽水區",
                        "善化區",
                        "大內區",
                        "山上區",
                        "新市區",
                        "安定區",
                    ],
                },
                {
                    name: "高雄市",
                    citys: [
                        "新興區",
                        "前金區",
                        "苓雅區",
                        "鹽埕區",
                        "鼓山區",
                        "旗津區",
                        "前鎮區",
                        "三民區",
                        "楠梓區",
                        "小港區",
                        "左營區",
                        "仁武區",
                        "大社區",
                        "岡山區",
                        "路竹區",
                        "阿蓮區",
                        "田寮區",
                        "燕巢區",
                        "橋頭區",
                        "梓官區",
                        "彌陀區",
                        "永安區",
                        "湖內區",
                        "鳳山區",
                        "大寮區",
                        "林園區",
                        "鳥松區",
                        "大樹區",
                        "旗山區",
                        "美濃區",
                        "六龜區",
                        "內門區",
                        "杉林區",
                        "甲仙區",
                        "桃源",
                        "那瑪夏區",
                        "茂林區",
                        "茄萣區",
                    ],
                },
                {
                    name: "澎湖縣",
                    citys: ["馬公市", "西嶼鄉", "白沙鄉", "湖西鄉"],
                },
                {
                    name: "屏東縣",
                    citys: [
                        "屏東市",
                        "三地門鄉",
                        "霧臺鄉",
                        "瑪家鄉",
                        "九如鄉",
                        "里港鄉",
                        "高樹鄉",
                        "鹽埔鄉",
                        "長治鄉",
                        "麟洛鄉",
                        "竹田鄉",
                        "內埔鄉",
                        "萬丹鄉",
                        "潮州鎮",
                        "泰武鄉",
                        "來義鄉",
                        "萬巒鄉",
                        "崁頂鄉",
                        "新埤鄉",
                        "南州鄉",
                        "林邊鄉",
                        "東港鎮",
                        "琉球鄉",
                        "佳冬鄉",
                        "新園鄉",
                        "枋寮鄉",
                        "枋山鄉",
                        "春日鄉",
                        "獅子鄉",
                        "車城鄉",
                        "牡丹鄉",
                        "恆春鎮",
                        "滿州鄉",
                    ],
                },
                {
                    name: "台東縣",
                    citys: [
                        "台東市",
                        "綠島鄉",
                        "延平鄉",
                        "卑南鄉",
                        "鹿野鄉",
                        "關山鎮",
                        "海端鄉",
                        "池上鄉",
                        "東河鄉",
                        "成功鎮",
                        "長濱鄉",
                        "太麻里鄉",
                        "金峰鄉",
                        "大武鄉",
                        "達仁鄉",
                    ],
                },
                {
                    name: "花蓮縣",
                    citys: [
                        "花蓮市",
                        "新城鄉",
                        "秀林鄉",
                        "吉安鄉",
                        "壽豐鄉",
                        "鳳林鎮",
                        "光復鄉",
                        "豐濱鄉",
                        "瑞穗鄉",
                        "萬榮鄉",
                        "玉里鎮",
                        "卓溪鄉",
                        "富里鄉",
                    ],
                },
                {
                    name: "金門縣",
                    citys: ["金沙鎮", "金寧鄉", "金城鎮", "烈嶼鄉"],
                },
                {
                    name: "連江縣",
                    citys: ["南竿鄉", "北竿鄉", "莒光鄉", "東引鄉"],
                },
            ],
            selectedCitys: [],
            //选择的地址
            selectedName: '',
            selectedCity: '',
            enteraddress: '',
            //发票
            bill: '1',
            //姓名
            name: '',
            //受買人名字
            company: '',
            //电话
            phone: '',
            //统一编号
            unite_number: '',
            //备注
            remark: '',
            //邮箱
            email: '',
            // default 配送方式
            selectedButton: 'default',
            //支付方式
            payButton: '',
            payshow: false,

            //Purchase
            content_ids: [],//预计是数组 各个商品的item+id
            content_name: 'V1_PURCHASE',
            contents: [],//预计是数组，个个商品的id
            num_items: '',//购物车的有多少件不同的商品数量
            // value:'',//购物车费用的总计
            // phone:'',//电话
            // ph:'',//电话
        };
    },
    computed: {
        subtotalStyle() {
            return !this.cart_contents ? 'height: 0px' : `height: ${this.contentheight}px`;
        },
        ...mapState('cart', ['freight', 'cart_list', 'cart_list_item', 'number']),
        ...mapState('order', ['payment_method', 'logistics', 'logistics_number']),
        ...mapState('commodity', ['addpurchase_list']),
        ...mapState('header', ['getfb', 'getads']),
        totalPriceAfterShipment() {
            // 确保将字符串转换为数字
            // console.log(this.cart_list.length);
            if (this.cart_list.item?.length > 0) {
                const total = parseFloat(this.cart_list.total.replace(/,/g, ''));
                // const shipmentUpperMoney = parseFloat(this.cart_list.shipment.replace(/,/g, ''));
                const shipmentUpperMoney = parseFloat(this.freight.total.replace(/,/g, ''));
                // console.log(total, shipmentUpperMoney);
                if (shipmentUpperMoney !== 0) {

                    return (total - shipmentUpperMoney); // 保留两位小数
                } else {

                    return total;
                }
            }
        },
        totalSum() {
            return this.child_list.reduce((sum, item) => sum + item.display_num, 0);
        }
    },
    filters: {
        formatNumberToqff(val) {
            return numeral(val).format('0,0');
        }
    },
    watch: {},
    methods: {
        onNameChange() {
            const selectedAddress = this.address.find((address) => address.name === this.selectedName);
            if (selectedAddress && selectedAddress.citys.length > 0) {
                this.selectedCitys = selectedAddress.citys;
                this.selectedCity = selectedAddress.citys[0];  // 默认选择第一个城市
            } else {
                this.selectedCitys = [];
                this.selectedCity = '';  // 如果没有城市，设置为空字符串
            }
        },
        callback() {
            console.log('callback FB');
        },
        // subtotal
        goorder() {
            this.cart_list.item.forEach(element => {
                // console.log(element);
                this.content_ids.push('item' + element.item_id);
                this.contents.push({ 'id': element.item_id, 'quantity': element.num })
            });
            var x = this.cart_list.total;
            var cartTotal = x.replace(/[^0-9.]/g, "");
            // console.log(cartTotal);
            var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash);
            var fb_em = myFacebookEventApi.fbgetCookie('em');
            var fb_phone = myFacebookEventApi.fbgetCookie('phone');
            var fb_fn = myFacebookEventApi.fbgetCookie('fn');
            var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
            var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');
            myFacebookEventApi.callPurchase2(this.callback(), this.content_ids, this.content_name, this.cart_list.item.length, this.contents, cartTotal, fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
            var GAFourEventApi = new GA4EventApi();
            GAFourEventApi.add_payment_info(this.cart_list, this.payButton);

            var note = this.remark.replace(/\n/g, " ");
            this.$store.dispatch('order/post',
                {
                    note: note,
                    address: this.selectedName + this.selectedCity + this.enteraddress,
                    email: this.email,
                    name: this.name,
                    phone: this.phone,
                }).then(() => {
                    this.$store.dispatch('cart/get').then(() => {

                    });
                    this.$store.dispatch('order/selectinvoice', {
                        order_number: this.$store.getters['order/submitorder'],
                        company:this.company,
                        email: this.email,
                        identifier: this.unite_number,
                        type: this.bill
                    }).then(() => {
                        //付款
                        this.$store.dispatch('order/payment', {
                            order_num: this.$store.getters['order/submitorder'],
                            type: this.payButton
                        }).then(() => {
                            // if (this.getads && this.getads.buy !== "") {
                            //     gtag('event', 'conversion', {
                            //         'send_to': this.getads.buy,
                            //         'value': this.cart_list.total,
                            //         'currency': 'TWD',
                            //         'transaction_id': ''
                            //     });
                            // }

                            this.$store.dispatch('order/logsucc_order');
                            sessionStorage.removeItem('addressData');
                            sessionStorage.removeItem('logistics');
                            sessionStorage.removeItem('pay_mode');
                            this.$store.dispatch('order/payment_two', { data: this.$store.getters['order/submitorder'] }).then((e) => {
                                if (e) {
                                    let item = this.$store.getters['order/order']
                                    GAFourEventApi.purchase(item[0]);
                                }
                            })
                            // GAFourEventApi.purchase(this.cart_list,this.$store.getters['order/submitorder']);
                            this.$router.push({
                                path: `/order/${this.$store.getters['order/submitorder']}`
                            }).catch(err => { })
                        });
                    });
                });
        },
        //选择配送方式
        selectButton(option) {
            // console.log(option);
            this.selectedButton = option;
            // this.$refs.provider.validate();
            // await this.$refs.provider.validate();
        },
        //选择付款方式
        select_payButton(e) {
            // console.log(e);
            this.payButton = e;
            var GAFourEventApi = new GA4EventApi();
            GAFourEventApi.add_payment_info(this.cart_list, this.payButton);
        },
        //修改发票方式
        changebill(e) {
            switch (e.target.value) {
                case '1':
                    this.bill = e.target.value;
                    // console.log(this.bill);
                    this.company = '';
                    break;

                case '2':
                    this.bill = e.target.value;
                    // console.log(this.bill);
                    break;
            }
        },
        // 数量减
        reduce(e, index) {

            let num = e.num;
            this.commodity_id = e.item_id
            if (num > 1) {
                this.$swal.fire({
                    allowOutsideClick: false, // 禁止点击外部关闭弹窗
                    customClass: {
                        popup: 'custom-swal'
                    },
                    didOpen: () => {
                        this.$swal.showLoading(); // 显示加载动画
                    }
                });
                if (e.sub.length !== 0) {

                    this.commodity_num = --num
                    this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                        this.free = response.data.sub_free || [];
                        this.free_num = response.data.num_free || 0;
                        this.child_list = response.data.sub || [];
                        this.child_num = response.data.num || 0;
                        if (response.data.sub.length === 1) {
                            this.child_list[0].display_num = response.data.num
                            switch (response.data.sub_free.length) {
                                case 0:
                                    this.parm = [
                                        {
                                            item: response.data.sub[0].isubid,
                                            num: response.data.num
                                        }
                                    ]
                                    break;
                                default:
                                    this.free_parm = this.free.map(item => {
                                        // number_free += item.display_num
                                        return {
                                            item: item.isubid,
                                            num: this.free_num * this.commodity_num
                                        };
                                    });
                                    this.parm = [
                                        {
                                            item: response.data.sub[0].isubid,
                                            num: response.data.num
                                        }
                                    ]
                                    break;
                            }
                            this.issub = true
                            this.checkChild_list(true)
                        } else
                            if (response.data.num != 0) {
                                this.ChildDialogVisible = true;
                                this.child_list = response.data.sub;
                                this.child_num = response.data.num * this.commodity_num;
                                this.issub = true
                            } else if (response.data.sub.length === 0) {

                                switch (response.data.sub_free.length) {
                                    case 0:
                                        this.parm = [
                                        ]
                                        break;
                                    default:
                                        this.free_parm = this.free.map(item => {
                                            // number_free += item.display_num
                                            return {
                                                item: item.isubid,
                                                num: this.free_num * this.number
                                            };
                                        });
                                        this.parm = [
                                        ]
                                        break;
                                }
                                this.issub = false
                                this.checkChild_list(true)
                            }
                        this.$swal.close();
                    });
                } else {
                    num = --e.num;
                    this.$store.dispatch("cart/update", {
                        itemid: e.item_id,
                        number: num,
                    }).then(() => {
                        this.$swal.close();
                    });
                }
            }
            // let num = e.num;
            // if (num > 1) {
            //     num = --e.num;
            //     this.$store.dispatch("cart/update", {
            //         itemid: e.item_id,
            //         number: num,
            //     }).then(() => {

            //     });
            // }
        },
        // 数量加
        add(e, index) {

            // console.log(e);
            let num = e.num;
            this.commodity_id = e.item_id
            if (num < 99) {
                this.$swal.fire({
                    allowOutsideClick: false, // 禁止点击外部关闭弹窗
                    customClass: {
                        popup: 'custom-swal'
                    },
                    didOpen: () => {
                        this.$swal.showLoading(); // 显示加载动画
                    }
                });
                if (e.sub.length !== 0) {
                    this.commodity_num = ++num
                    this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                        this.free = response.data.sub_free || [];
                        this.free_num = response.data.num_free || 0;
                        this.child_list = response.data.sub || [];
                        this.child_num = response.data.num || 0;
                        if (response.data.sub.length === 1) {
                            this.child_list[0].display_num = response.data.num
                            switch (response.data.sub_free.length) {
                                case 0:
                                    this.parm = [
                                        {
                                            item: response.data.sub[0].isubid,
                                            num: response.data.num
                                        }
                                    ]
                                    break;
                                default:
                                    this.free_parm = this.free.map(item => {
                                        // number_free += item.display_num
                                        return {
                                            item: item.isubid,
                                            num: this.free_num * this.commodity_num
                                        };
                                    });
                                    this.parm = [
                                        {
                                            item: response.data.sub[0].isubid,
                                            num: response.data.num
                                        }
                                    ]
                                    break;
                            }
                            this.issub = true
                            this.checkChild_list(true)
                        } else
                            if (response.data.num != 0) {
                                this.ChildDialogVisible = true;
                                this.child_list = response.data.sub;
                                this.child_num = response.data.num * this.commodity_num;
                                this.issub = true
                            } else if (response.data.sub.length === 0) {

                                switch (response.data.sub_free.length) {
                                    case 0:
                                        this.parm = [
                                        ]
                                        break;
                                    default:
                                        this.free_parm = this.free.map(item => {
                                            // number_free += item.display_num
                                            return {
                                                item: item.isubid,
                                                num: this.free_num * this.number
                                            };
                                        });
                                        this.parm = [
                                        ]
                                        break;
                                }
                                this.checkChild_list(true)
                                this.issub = false
                            }
                        this.$swal.close();
                    });
                } else {
                    num = ++e.num;
                    this.$store.dispatch("cart/update", {
                        itemid: e.item_id,
                        number: num,
                    }).then(() => {
                        this.$swal.close();
                    });
                }
            }




            // this.getProducts(e.item_id);
            // let num = e.num;
            // if (num < 99) {
            //     num = ++e.num;
            //     this.$store.dispatch("cart/update", {
            //         itemid: e.item_id,
            //         number: num,
            //     }).then(() => { });
            // }
        },
        // 删除
        del(e) {
            // console.log(e);
            this.$swal.fire({
                allowOutsideClick: false, // 禁止点击外部关闭弹窗
                customClass: {
                    popup: 'custom-swal'
                },
                didOpen: () => {
                    this.$swal.showLoading(); // 显示加载动画
                }
            });
            let param = [];
            if (e.sub.length !== 0) {
                param = e.sub.map(item => {
                    return {
                        item: item.isubid,
                        num: 0
                    };
                })
            }
            this.$store.dispatch("cart/del", {
                itemid: e.item_id,
                param: param,
            }).then(() => {
                this.$swal.close();
                if (this.cart_list_item.length == 0) {
                    // console.log(123);
                    this.$router.push({
                        path: `/`
                    }).catch(err => { })

                }
            });
        },
        //修改数量
        changebalue(e, index) {
            this.$swal.fire({
                allowOutsideClick: false, // 禁止点击外部关闭弹窗
                customClass: {
                    popup: 'custom-swal'
                },
                didOpen: () => {
                    this.$swal.showLoading(); // 显示加载动画
                }
            });
            //  let num = e.num;
            //  e.num = ++e.num ;
            this.commodity_num = e.num;
            this.commodity_id = e.item_id
            if (e.sub.length !== 0) {
                this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                    this.free = response.data.sub_free || [];
                    this.free_num = response.data.num_free || 0;
                    this.child_list = response.data.sub || [];
                    this.child_num = response.data.num || 0;
                    if (response.data.sub.length === 1) {
                        this.child_list[0].display_num = response.data.num
                        switch (response.data.sub_free.length) {
                            case 0:
                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                break;
                            default:
                                this.free_parm = this.free.map(item => {
                                    // number_free += item.display_num
                                    return {
                                        item: item.isubid,
                                        num: this.free_num * this.commodity_num
                                    };
                                });
                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                break;
                        }
                        this.issub = true
                        this.checkChild_list(true)
                    } else
                        if (response.data.num != 0) {
                            this.ChildDialogVisible = true;
                            this.child_list = response.data.sub;
                            this.child_num = response.data.num * this.commodity_num;
                            this.issub = true
                        } else if (response.data.sub.length === 0) {

                            switch (response.data.sub_free.length) {
                                case 0:
                                    this.parm = [
                                    ]
                                    break;
                                default:
                                    this.free_parm = this.free.map(item => {
                                        // number_free += item.display_num
                                        return {
                                            item: item.isubid,
                                            num: this.free_num * this.number
                                        };
                                    });
                                    this.parm = [
                                    ]
                                    break;
                            }
                            this.checkChild_list(true)
                            this.issub = false
                        }
                    this.$swal.close();
                });
            } else {
                this.$store.dispatch("cart/update", {
                    itemid: e.item_id,
                    number: e.num,
                }).then(response => {
                    this.$swal.close();
                });
            }
            // this.getProducts(e.item_id);
            // let num = e.num;
        },
        //加购商品加入购物车
        addcart(item) {
            this.$swal.fire({
                allowOutsideClick: false, // 禁止点击外部关闭弹窗
                customClass: {
                    popup: 'custom-swal'
                },
                didOpen: () => {
                    this.$swal.showLoading(); // 显示加载动画
                }
            });
            this.$store.dispatch('cart/add', {
                itemid: item.itemid,
                number: 1,
            }).then(response => {
                this.$swal.fire({
                    html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
          <circle class="circle" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="36.7" cy="36.7" r="35.2"></circle>
          <polyline class="success_path" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="23.7,36.8 32.4,45.4 49.7,28 "></polyline>
        </svg><div>已加入購物車</div>`,
                    showConfirmButton: false,
                    customClass: {
                        popup: 'icon-popup'
                    },
                });
                // 设置延时器在一秒后关闭弹窗
                setTimeout(() => {
                    this.$swal.close();
                }, 1000); // 1000 毫秒等于 1 秒

            });
        },
        //子商品
        getProducts(id) {
            this.$store.dispatch('commodity/getsubcategory', id).then(response => {
                if (response.result) {
                    if (response.data.num != 0) {
                        this.ChildDialogVisible = true;
                        this.child_list = response.data.sub;
                        this.child_num = response.data.num;
                        this.issub = true
                    } else {
                        this.issub = false
                    }
                } else {
                    this.$notify({
                        title: `${response.message}`,
                        type: 'warning'
                    });
                    this.issub = false
                }
            });
        },
        increment(index) {
            if (this.totalSum < this.child_num) {
                this.child_list[index].display_num++;
            }
        },
        validateInput(index) {
            // 确保当前输入是一个有效数字
            this.child_list[index].display_num = Math.max(0, parseInt(this.child_list[index].display_num) || 0);

            // 计算所有 display_num 的总和
            let total = this.child_list.reduce((sum, item) => sum + item.display_num, 0);

            // 如果总和超过 child_num，则减少当前输入的值
            if (total > this.child_num) {
                let excess = total - this.child_num;
                this.child_list[index].display_num = Math.max(0, this.child_list[index].display_num - excess);
            }
        },
        decrement(index) {
            if (this.child_list[index].display_num > 0) {
                this.child_list[index].display_num--;
            }
        },
        checkChild_list(e) {
            let number = 0
            if (e) {

                this.parm = this.child_list.map(item => {
                    number += item.display_num
                    return {
                        item: item.isubid,
                        num: item.display_num * this.commodity_num
                    };
                });
            } else {

                this.parm = this.child_list.map(item => {
                    number += item.display_num
                    return {
                        item: item.isubid,
                        num: item.display_num
                    };
                });
            }
            this.free_parm = this.free.map(item => {
                // number_free += item.display_num
                return {
                    item: item.isubid,
                    num: this.free_num * this.commodity_num
                };
            });
            this.parm = this.parm.concat(this.free_parm);
            this.free_parm = [];
            // console.log(number, this.child_num, '点击后的number和child_num');
            if (number == this.child_num) {
                this.ChildDialogVisible = false;

                this.$swal.fire({
                    allowOutsideClick: false, // 禁止点击外部关闭弹窗
                    customClass: {
                        popup: 'custom-swal'
                    },
                    didOpen: () => {
                        this.$swal.showLoading(); // 显示加载动画
                    }
                });
                this.$store.dispatch('cart/child_update', {
                    itemid: this.commodity_id,
                    number: this.commodity_num,
                    param: this.parm
                }).then(response => {

                    this.$swal.fire({
                        html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
          <circle class="circle" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="36.7" cy="36.7" r="35.2"></circle>
          <polyline class="success_path" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="23.7,36.8 32.4,45.4 49.7,28 "></polyline>
        </svg><div>已修改商品</div>`,
                        showConfirmButton: false,
                        customClass: {
                            popup: 'icon-popup'
                        },
                    });
                    // 设置延时器在一秒后关闭弹窗
                    setTimeout(() => {
                        this.$swal.close();
                    }, 1000); // 1000 毫秒等于 1 秒
                    // this.$notify({
                    //     title: '已修改商品',
                    //     type: 'success'
                    // });
                });
                // console.log(this.parm);
            } else {
                this.$notify({
                    title: `數量選擇有錯哦! 您可以選 ${this.child_num} 樣商品^_^`,
                    type: 'warning'
                });
            }
        },
        //失去焦点保存信息
        insert() {

            if (this.name) {
                document.cookie = "fn=" + this.name + ";path=/;max-age=172800"; // Cookie 保存2天
            }
            if (this.email) {
                document.cookie = "em=" + this.email + ";path=/;max-age=172800"; // Cookie 保存2天
            }
            if (this.phone) {
                document.cookie = "external_id=" + this.phone + ";path=/;max-age=172800"; // Cookie 保存2天
                document.cookie = "phone=" + this.phone + ";path=/;max-age=172800"; // Cookie 保存2天
            }
            // console.log(1);
            this.$store.dispatch('user/save', {
                address: this.selectedName + '|' + this.selectedCity + '|' + this.enteraddress,
                name: this.name,
                phone: this.phone,
            }).then(() => {
                // this.$store.dispatch('user/get').then(() => { });
            });
        },
    },
    created() {
    },
    mounted() {
        this.$store.dispatch('cart/get').then((e) => {
            this.$nextTick(() => {
                this.contentheight = document.getElementById('subtotal').offsetHeight
            });
            if (e.length == 0) {
                this.$router.push({
                    path: `/`
                }).catch(err => { })
            }
        });
        this.$swal.fire({
            allowOutsideClick: false, // 禁止点击外部关闭弹窗
            customClass: {
                popup: 'custom-swal'
            },
            didOpen: () => {
                this.$swal.showLoading(); // 显示加载动画
            }
        });
        // console.log(1);

        function updateNavHeaderHeight() {
            var navHeaderHeight = document.getElementById('header').offsetHeight;
            // var FooterHeight = document.getElementById('footer').offsetHeight;
            document.getElementById('router_viewbody').style.paddingTop = navHeaderHeight + 'px';
            // document.getElementById('router_viewbody').style.height  = `calc(100vh - ${navHeaderHeight+FooterHeight}px)`;
            return navHeaderHeight;
        }
        if (typeof window !== 'undefined') {

            updateNavHeaderHeight();
            window.addEventListener('load', function () {
                // 获取navheader的高度
                var navHeaderHeight = document.getElementById('header').offsetHeight;
                var lefdetail = document.getElementById('detail');
                // // 设置body的padding-top为navheader的高度
                document.getElementById('router_viewbody').style.paddingTop = navHeaderHeight + 'px';


                // // 监听滚动事件
                var navHeader = document.getElementById('header');
                var lastScrollTop = 0;
                window.addEventListener('scroll', function () {
                    var navHeaderHeight = updateNavHeaderHeight();
                    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    // console.log(scrollTop); router_viewbody
                    let footertop = document.getElementById('router_viewbody').getBoundingClientRect();
                    // console.log(footertop);
                    // console.log(window.screen.width,'12');
                    var current_width = window.innerWidth;
                    if (scrollTop > lastScrollTop) {
                        // 向下滚动
                        if (scrollTop > navHeaderHeight) {
                            navHeader.style.top = -navHeaderHeight + 'px';
                            if (current_width > 991) {

                                lefdetail.style.top = 20 + 'px';
                                if (footertop.y < -1063) {
                                    lefdetail.style.position = 'absolute';
                                    lefdetail.style.bottom = '0px';
                                    lefdetail.style.top = '';
                                } else {
                                    lefdetail.style.position = 'fixed';
                                    lefdetail.style.bottom = '';
                                }
                            }

                        }

                    } else {
                        // 向上滚动
                        navHeader.style.top = '0';
                        if (current_width > 991) {

                            lefdetail.style.top = navHeaderHeight + 20 + 'px';
                            if (footertop.y > -970) {
                                lefdetail.style.position = 'fixed';
                                lefdetail.style.bottom = '';
                            } else {
                                lefdetail.style.top = '';
                                lefdetail.style.bottom = '0px';
                            }
                        }


                    }
                    lastScrollTop = scrollTop;
                });


            });
            window.addEventListener('resize', function () {
                var current_width = window.innerWidth;
                var navHeaderHeight = document.getElementById('header').offsetHeight;
                // console.log(navHeaderHeight);
                if (current_width < 991) {
                    document.getElementById('detail').style.top = 0 + 'px';
                } else {
                    document.getElementById('detail').style.top = navHeaderHeight + 20 + 'px';
                }
                // 当窗口大小改变时，重新计算navHeaderHeight
                updateNavHeaderHeight();
            });
        }
        this.$store.dispatch('order/get_logistics').then(e => {
        });
        this.$store.dispatch('user/get').then(() => { });
        this.$store.dispatch('order/get').then(() => {
            const GAFourEventApi = new GA4EventApi();
            GAFourEventApi.view_cart(this.cart_list);
        });
        this.$store.dispatch('commodity/getpurchase').then((e) => {
            // console.log(e);
            this.$swal.close();
        })



        // this.selectedName='台北市'
        // this.onNameChange()
        // this.selectedCity='萬華區'
    },
}
</script>

<style src="./index.scss" lang='scss' scoped></style>